import { Injectable } from '@angular/core';

export const enum mobileEvents {
  rxEventShowHeader = 'rxEventShowHeader',
  rxEventHideHeader = 'rxEventHideHeader',
  rxEventLogout = 'rxEventLogout',
  rxEventCall = 'rxEventCall',
  rxEventChat = 'rxEventChat',
  rxEventError = 'rxEventError',
  rxEventSignForm = 'rxEventSignForm',
  rxEventAttachment = 'rxEventAttachment',
  rxBackToClientPage = 'rxBackToClientPage',
  rxBackToBillsPage = 'rxBackToBillsPage',
  rxEventReportForDownload = 'rxEventReportForDownload',
  rxEventOpenLinkInDeviceBrowser = 'rxEventOpenLinkInDeviceBrowser',
}

@Injectable({
  providedIn: 'root',
})
export class WebviewService {
  // Failsafe, in case iOS or Android does not provide particular event + WebBrower mode
  private defaultHandlerMethod = {
    standalone: true,
    postMessage: (params) => {
      console.log('Warning: WebView not detected.');
      return -1;
    },
  };

  constructor() {}

  public showHeader() {
    return this.send(mobileEvents.rxEventShowHeader);
  }

  public hideHeader() {
    return this.send(mobileEvents.rxEventHideHeader);
  }

  public sendReportForDownload(payload) {
    return this.send(mobileEvents.rxEventReportForDownload, payload);
  }

  public sendOpenLinkInDeviceBrowser(payload) {
    return this.send(mobileEvents.rxEventOpenLinkInDeviceBrowser, payload);
  }

  public logout() {
    return this.send(mobileEvents.rxEventLogout);
  }

  public chat() {
    return this.send(mobileEvents.rxEventChat);
  }

  public call() {
    return this.send(mobileEvents.rxEventCall);
  }

  public sign(payload) {
    return this.send(mobileEvents.rxEventSignForm, payload);
  }

  public attachment(payload) {
    return this.send(mobileEvents.rxEventAttachment, payload);
  }

  public error(payload) {
    return this.send(mobileEvents.rxEventError, payload);
  }

  public backToClientPage() {
    return this.send(mobileEvents.rxBackToClientPage);
  }

  public backToBillsPage() {
    return this.send(mobileEvents.rxBackToBillsPage);
  }

  public handler(event: string) {
    // iOS detected

    if (
      (window as any).webkit !== undefined &&
      (window as any).webkit.messageHandlers !== undefined &&
      (window as any).webkit.messageHandlers[event]
    ) {
      return (window as any).webkit.messageHandlers[event] || this.defaultHandlerMethod;
    }

    // Android detected

    if ((window as any)[event] !== undefined) {
      return (window as any)[event] || this.defaultHandlerMethod;
    }

    // Standalone browser mode

    return this.defaultHandlerMethod;
  }

  public send(event, message: any = { flag: true }) {
    return this.handler(event).postMessage(message);
  }
}
